import React from 'react';
import Layout from '@/layouts';
import Head from 'next/head';
import { AppSettings } from '@/shared/app-common';
import { NextPageWithLayout } from './_app';
import dynamic from 'next/dynamic';
import type { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { canonicalUrl } from '@/shared/utils';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale, req, resolvedUrl } = context;

  const localeRes = await serverSideTranslations(locale, ['common']);
  const tempData = localeRes['_nextI18Next']['initialI18nStore'][locale]['common'] ?? {};

  return {
    props: {
      ...localeRes,
      herf: canonicalUrl(req.headers.host, resolvedUrl, locale),
      locale,
      title: tempData['head_Meta_Title'],
      description: tempData['head_Meta_Desc'],
    },
  };
};

const ExtesionUninstall = dynamic(() => import('@/components/ExtesionUninstall'), {
  ssr: true,
});

const ExtensionUninstallPage: NextPageWithLayout = (data) => {
  return <ExtesionUninstall />;
};

ExtensionUninstallPage.getLayout = function getLayout(page: React.ReactElement) {
  return (
    <Layout
      head={
        <Head>
          <title>{AppSettings.title}</title>
          <meta name="title" content={AppSettings.title} />
          <meta name="description" content={AppSettings.desc} />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="icon" href={AppSettings.icoPath} />
          <meta name="robots" content="noindex" />
        </Head>
      }
    >
      {page}
    </Layout>
  );
};

export default ExtensionUninstallPage;
